<template>
  <form @submit.prevent="submit" :class="errorClass">
    <rp-textinput
      v-model="resource.first_name"
      placeholder="First Name"
      :error="first_nameError"
      isRequired
      @input="touch('first_name')"/>

    <rp-textinput
      v-model="resource.last_name"
      placeholder="Last Name"
      :error="last_nameError"
      isRequired
      @input="touch('last_name')"/>

    <rp-textinput
      v-model="resource.email"
      placeholder="Email"
      :disabled="true"
      :error="emailError"
      isRequired
      @input="touch('email')"/>

    <rp-button :disabled="isInvalid" type="primary">Update</rp-button>
  </form>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {email, required} from 'vuelidate/lib/validators'
  import {errorMessages} from '../../../api/error_messages'

  import form from '../../../mixins/form'

  import Button from '../../../components/ui/inputs/Button'
  import TextInput from '../../../components/ui/inputs/TextInput'

  export default {
    name: 'LoginForm',
    mixins: [validationMixin, form],

    components: {
      'rp-button': Button,
      'rp-textinput': TextInput
    },

    computed: {
      ...errorMessages([
        'first_name',
        'last_name',
        'email'
      ])
    },
    validations: {
      resource: {
        first_name: {required},
        last_name: {required},
        email: {required, email}
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/forms/UserSettings.vue